import { Box, Pressable, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const MapContainer = Box.withConfig({
  height: {
    base: '$40',
    md: '$48',
  },
});

export const PressableStoreContainer = Pressable.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: primitive.$white,
  paddingX: '$4',
  paddingY: '$3',
  height: '$24',
  overflow: 'hidden',
  shadow: '1',
});

export const BoldText = Text.withConfig({
  variant: 'headerThree',
  margin: 0,
});

export const Address = Text.withConfig({
  variant: 'copyOne',
});

export const Directions = Text.withConfig({
  variant: 'copyOne',
  underline: true,
  marginY: '$1',
});

export const PickUpTimeContainer = Box.withConfig(
  ({ showBorderRadius = true }: { showBorderRadius?: boolean }) => ({
    flexDirection: 'column',
    backgroundColor: primitive.$white,
    paddingX: '$4',
    paddingY: '$3',
    height: '$24',
    borderTopWidth: '1px',
    borderTopColor: primitive.$greyFive,
    borderTopStyle: 'solid',
    ...(showBorderRadius && { borderBottomRadius: primitive.$borderRadius }),
    overflow: 'hidden',
    shadow: '1',
  })
);

export const PickUpWindowAlertContainer = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: primitive.$errorLight,
  height: '$9',
  paddingX: '$4',
  borderTopWidth: '1px',
  borderTopColor: primitive.$greyFive,
  borderTopStyle: 'solid',
  borderBottomRadius: primitive.$borderRadius,
  overflow: 'hidden',
  shadow: '1',
});

export const PickUpWindowAlert = Text.withConfig({
  variant: 'copyOne',
  fontWeight: 'bold',
  fontSize: 'xs',
  marginLeft: '$1',
});
